module.exports = __webpack_public_path__ + "static/media/img_video_interview.a6d09546.png";